// src/pages/Welcome/FeaturesSection.jsx
import React from 'react';
import { welcomeStyles } from './styles';
import { SearchIcon, BrowseIcon, SchoolIcon } from '../../components/Icons';

const FeaturesSection = () => {
  return (
    <section style={welcomeStyles.featuresSection}>
      <div style={welcomeStyles.featuresContent}>
        <div style={welcomeStyles.featuresGrid}>
          <div style={welcomeStyles.featureCard}>
            <div style={welcomeStyles.featureIcon}>
              <SearchIcon size={40} color="white" fill="white" style={{ color: 'white !important', fill: 'white !important' }} />
            </div>
            <h3 style={welcomeStyles.featureTitle}>Easy Discovery</h3>
            <p style={welcomeStyles.featureDescription}>
              Smart search and filters to quickly find exactly what you need from fellow students.
            </p>
          </div>
          
          <div style={welcomeStyles.featureCard}>
            <div style={welcomeStyles.featureIcon}>
              <BrowseIcon size={40} color="white" fill="white" style={{ color: 'white !important', fill: 'white !important' }} />
            </div>
            <h3 style={welcomeStyles.featureTitle}>Browse & Connect</h3>
            <p style={welcomeStyles.featureDescription}>
              Discover listings from fellow students and connect directly with sellers on campus.
            </p>
          </div>
          
          <div style={welcomeStyles.featureCard}>
            <div style={welcomeStyles.featureIcon}>
              <SchoolIcon size={40} color="white" fill="white" style={{ color: 'white !important', fill: 'white !important' }} />
            </div>
            <h3 style={welcomeStyles.featureTitle}>Student-Friendly</h3>
            <p style={welcomeStyles.featureDescription}>
              Built by students, for students. Understand your budget, schedule, and campus life.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;